"use strict";

var _useResolvedSupplierIdListQuery;
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useMemo, useRef, useState } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { useViewerPreferences } from '@autoguru/viewer-preferences';
import { useSupplierMeta } from './useSupplierMeta';
const isAdminEmail = email => email.includes('@autoguru.com.au');
export const useResolvedSupplierId = ({
  routeSupplierId: incomingRouteSupplierId,
  retailSupplierId
}) => {
  var _viewer$clientPrefere2;
  const {
    suppliers,
    viewer
  } = useLazyLoadQuery(_useResolvedSupplierIdListQuery !== void 0 ? _useResolvedSupplierIdListQuery : _useResolvedSupplierIdListQuery = require("../../relay/__generated__/useResolvedSupplierIdListQuery.graphql"), {});
  const isGroupViewer = suppliers.pageInfo.hasNextPage;
  const [, updateViewerPreferences] = useViewerPreferences();
  const firstSupplier = useSupplierMeta({
    supplier: suppliers.nodes[0]
  });
  const isImpersonatingRef = useRef(isAdminEmail(viewer.emailAddress));
  const [routeSupplierId, setRouteSupplierId] = useState(incomingRouteSupplierId);
  const defaultViewerId = useMemo(() => {
    var _viewer$clientPrefere;
    if (isImpersonatingRef.current) return retailSupplierId || routeSupplierId;
    if (isGroupViewer) return routeSupplierId || ((_viewer$clientPrefere = viewer.clientPreferences) === null || _viewer$clientPrefere === void 0 ? void 0 : _viewer$clientPrefere.preferredSupplierId);
    return firstSupplier === null || firstSupplier === void 0 ? void 0 : firstSupplier.dbId.toString();
  }, [isGroupViewer, routeSupplierId, retailSupplierId, firstSupplier, (_viewer$clientPrefere2 = viewer.clientPreferences) === null || _viewer$clientPrefere2 === void 0 ? void 0 : _viewer$clientPrefere2.preferredSupplierId]);
  const [resolvedSupplierId, setResolvedSupplierId] = useState(defaultViewerId);
  const defaultViewerIdRef = useRef(defaultViewerId);
  useEffect(() => {
    if (typeof resolvedSupplierId === 'undefined' && defaultViewerId !== defaultViewerIdRef.current) {
      // Previous default no longer valid
      defaultViewerIdRef.current = defaultViewerId;
      setResolvedSupplierId(defaultViewerId);
    }
  }, [resolvedSupplierId, defaultViewerId]);
  return {
    resolvedSupplierId,
    isGroupViewer,
    isImpersonating: isImpersonatingRef.current,
    setViewerSupplierId: id => {
      updateViewerPreferences({
        preferredSupplierId: id
      });
      setResolvedSupplierId(id);
    },
    setRouteSupplierId
  };
};